exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-hop-demo-js": () => import("./../../../src/pages/hop-demo.js" /* webpackChunkName: "component---src-pages-hop-demo-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-review-bethel-cafe-js": () => import("./../../../src/pages/review/bethel-cafe.js" /* webpackChunkName: "component---src-pages-review-bethel-cafe-js" */)
}

